export const environment = require("./envConfig.js");
